import {
  addExpenseAccount,
  getAllSupplier,
  getChartExpense,
  getStatesData,
  getUserAccountList,
  handleKeyDown,
  makePaymentApi,
  uploadFiles,
  venderDropdownApi,
} from "_services";
import {
  CityDropdownForTrip,
  CommonCanvas,
  CommonDatePicker,
  CommonInput,
  CommonModal,
  CommonSwitch,
  CustomSelect,
} from "components";
import { constant } from "constants/constant";
import { Images } from "constants";
import { UserContext } from "context";
import { errorSchema, utils } from "helper";
import React, { useCallback, useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { IoCloseCircle } from "react-icons/io5";
import StorageService from "utils/StorageServices";
import { getBranchListApi, getConsignorDropdownListData2, getDriverDropdownListData, getFuelApi } from "_services/dropdownServices/dropdownService";
import AddExpenseCategoryModal from "modals/AddExpenseCategoryModal";
import { AddEditOwnDriver, AddEditStaff, AddEditVendors } from "modals";
import FirmImg from '../../assets/img/firm.png';
import { getAllPermissions } from "utils/permissionHelper";
import { getSupplierListData } from "_services/accountsServices/supplierServices";
import { getConsignorListData } from "_services/accountsServices/consignorServices";
import { getFastagCompanyDropdownData, getFuelCardAccountDropdownData } from "_services/accountsServices/fuelStationServices";
import AddEditSupplier from "modals/AddEditSupplier";
import AddEditConsignor from "modals/AddEditConsignor/AddEditConsignor";
import AddEditFuelStation from "modals/AddEditFuelStation";
import { useNavigate } from "react-router-dom";
import { getStaffListData } from "_services/accountsServices/staffServices";

// ─── GST calculation (inclusive / exclusive) ─────────────────────────────────
// tax_type === 1 → Exclusive: tax added ON TOP
// tax_type === 0 → Inclusive: tax already INSIDE amount — extract it
const calcGst = (tax, amount, tax_type) => {
  if (!tax || !amount) return 0;
  const raw =
    tax_type === 1
      ? (amount * (tax / 2)) / 100
      : (amount * tax) / (2 * (100 + tax));
  return parseFloat(raw.toFixed(2));
};

const AddExpensesModal = (props) => {

  const { isEditDetails, isOpen } = props;

  const arryOptions = [
    { label: "Goods", value: "Goods" },
    { label: "Service", value: "Service" },
  ];

  const initial = {
    date: new Date(),
    is_gst: 0,
    is_invoice: false,
    tax_type: 0,
    total_amount: "",
    account_category: 1,
    account_sub_category: 15,
    account_id: "",
    vendor_type: 4,
    vendor_id: {},
    invoice_number: "",
    invoice_date: new Date(),
    place_of_supply: {},
    branch_id: {},
    company_id: StorageService.getCompanyId(),
    expenses: [],
    file: [],
  };

  const expenseInit = {
    category: '',
    tax: '',
    hsn_code: "",
    description: "",
    type: "",
    amount: "",
  };

  const { masterData, generalExpensesIndex, setGeneralExpensesIndex, mastersChild, allMenu } = useContext(UserContext);
  const masterChildVendors = mastersChild?.find((i) => i?.label === "Vendors");
  const masterChildSupplier = mastersChild?.find((i) => i?.label === "Supplier");
  const masterChildConsignor = mastersChild?.find((i) => i?.label === "Party");
  const masterChildDriver = mastersChild?.find((i) => i?.label === "Driver");
  const masterChildFuelStation = mastersChild?.find((i) => i?.label === "Fuel Station");
  const masterChildStaff = mastersChild?.find((i) => i?.label === "Staff");


  const hasLinkCharofAccountPermission = getAllPermissions("/accounting/chartofaccounts", allMenu, 'link');
  const navigate = useNavigate()
  const [form, setForm] = useState(initial);
  const [expenseTypeList, setExpenseTypeList] = useState([]);
  const [expenseList, setExpenseList] = useState([]);
  const [expenseArray, setExpenseArray] = useState([expenseInit]);
  const [formError, setFormError] = useState("");
  const [gstTaxList, setGstTaxList] = useState([]);
  const [accountLoading, setAccountLoading] = useState(false);
  const [accountList, setAccountList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [accountType, setAccountType] = useState(null);
  const [isLoadding, setIsLoadding] = useState(false);
  const [isLoaddingforsave, setIsLoaddingForSave] = useState(false);
  const [aprroveStatus, setAprroveStatus] = useState();
  const [venderList, setVenderList] = useState([]);
  const [statesList, setStatesList] = useState([]);
  const [isOpenVenderModal, setIsOpenVenderModal] = useState(false);
  const [venderSelection, setVenderSelection] = useState(false);
  const [isSupply, setIsSupply] = useState({});
  const [gstTypeAmount, setGstTypeAmount] = useState([]);
  const [addNewExpense, setAddNewExpense] = useState(false);
  const [showOffcanvasSupplier, setShowOffcanvasSupplier] = useState(false);
  const [showOffcanvasConsignor, setShowOffcanvasConsignor] = useState(false);
  const [showOffcanvasDriver, setShowOffcanvasDriver] = useState(false);
  const [showOffcanvasFuel, setShowOffcanvasFuel] = useState(false);
  const [showOffcanvasStaff, setShowOffcanvasStaff] = useState(false)

  // ─── lifecycle ──────────────────────────────────────────────────────────────
  useEffect(() => {
    getMasterData();
    getExpenseHandler();
  }, [masterData]);

  useEffect(() => {
    fetchBranch();
    getStatesByApi();
  }, []);

  useEffect(() => {
    if (accountType) {
      setForm((s) => ({ ...s, account_id: '' }));
    }
  }, [accountType]);

  useEffect(() => {
    if (!isEditDetails?.isEdit && form?.branch_id?.value) {
      const branchFirmId = form?.branch_id?.firm_id?._id || StorageService.getFirmId();
      const vendorFirmId = form?.vendor_id?.firm_id?._id || form?.vendor_id?.firm_id;

      if (vendorFirmId && branchFirmId && vendorFirmId !== branchFirmId) {
        // ❌ Firm mismatch — vendor clear karo
        setForm((s) => ({ ...s, vendor_id: {}, place_of_supply: {} }));
        setIsSupply({});
      }
    }
  }, [form?.branch_id?.value]);


  // ─── 3. venderSelection useEffect: modal se add hone par firm check ───────────
  useEffect(() => {
    if (venderSelection) {
      const obj = venderSelection?.value ? venderSelection : venderList[0];
      console.log(venderSelection)

      const branchFirmId = form?.branch_id?.firm_id?._id || StorageService.getFirmId();
      const vendorFirmId = obj?.firm_id?._id || obj?.firm_id;

      if (vendorFirmId && branchFirmId && vendorFirmId !== branchFirmId) {
        // ❌ Firm mismatch — clear karo
        setForm((s) => ({ ...s, vendor_id: {}, place_of_supply: {} }));
        setIsSupply({});
        toast.error("Vendor firm does not match the selected branch firm.");
      } else {
        // ✅ Same firm — set karo
        handleOnChange("vendor_id", obj);
        setIsSupply(obj);

        //   if (obj?.gst_no) {
        //   setForm((s) => ({
        //     ...s,
        //     vendor_id: obj,
        //     is_invoice: true,
        //     is_gst: 1,
        //     tax_type: 1,
        //   }));
        // } else {
        //   setForm((s) => ({
        //     ...s,
        //     vendor_id: obj,
        //     is_gst: 0,
        //     tax_type: 0,
        //   }));
        // }
        if (obj?.gst_state?.label || obj?.gst_state?.value) {
          setForm((s) => ({
            ...s,
            vendor_id: obj,
            is_invoice: true,
            is_gst: 1,
            tax_type: 1,
          }));
        } else {
          setForm((s) => ({
            ...s,
            vendor_id: obj,
            is_gst: 0,
            tax_type: 0,
          }));
        }
      }
    }
  }, [venderSelection, venderList]);


  // vendor_type change hone par vendor_id aur isSupply clear karo
  useEffect(() => {
    if (!isEditDetails?.isEdit) {
      setForm((s) => ({ ...s, vendor_id: {} }));
      setIsSupply({});
    }
  }, [form?.vendor_type]);

  useEffect(() => {
    console.log("isSupply", isSupply)
    if (statesList?.length > 0 && !isEditDetails?.isEdit) {
      const supplyLabel = isSupply?.gst_state?.label?.toLowerCase()?.trim();
      const supplyValue = isSupply?.gst_state?.value?.toLowerCase()?.trim();

      const object = statesList?.find((el) => {


        const elName = el?.name?.toLowerCase()?.trim();
        const elValue = el?.value?.toLowerCase()?.trim();
        console.log("newObj", elValue, elName, supplyLabel, supplyValue)
        return elName === supplyLabel || elName === supplyValue || elValue === supplyLabel || elValue === supplyValue;
      });

      const newObj = (object?.name && object?._id)
        ? { ...object, label: object?.name || '', value: object?.name || '' }
        : null;

      console.log("newObj", newObj, object)

      setForm((s) => ({ ...s, place_of_supply: newObj?.label ? newObj : {} }));
    }
  }, [isSupply, isEditDetails, statesList]);

  useEffect(() => {
    if (!isEditDetails?.isEdit) {
      const newArray = expenseArray?.map((el) => ({
        ...el,
        gst: calcGst(el?.tax, el?.amount, form?.tax_type),
      }));
      setGstTypeAmount(newArray);
    }
  }, [expenseArray, form?.tax_type, isEditDetails]);

  useEffect(() => {
    if (isEditDetails?.isEdit) {
      const customArray = isEditDetails?.categories?.map((el) => ({
        ...el,
        category: { label: el?.category?.name, value: el?.category?._id }
      }));
      setExpenseArray(customArray);

      setForm((s) => ({
        ...s,
        date: new Date(isEditDetails?.date),
        is_gst: isEditDetails?.is_gst,
        is_invoice: isEditDetails?.is_invoice,
        tax_type: isEditDetails?.tax_type,
        total_amount: isEditDetails?.total_amount,
        account_category: 1,
        account_sub_category: 15,
        account_id: isEditDetails?.payment_mode?.account?._id,
        old_account_id: isEditDetails?.payment_mode?.account_sub_category != 15
          ? isEditDetails?.payment_mode?.account?._id : '',
        vendor_type: isEditDetails?.vendor_type,
        vendor_id: isEditDetails?.vendor_detail?._id,
        invoice_number: isEditDetails?.invoice_number,
        invoice_date: new Date(isEditDetails?.invoice_date),
        place_of_supply: {
          ...isEditDetails?.place_of_supply,
          label: isEditDetails?.place_of_supply?.name,
          value: isEditDetails?.place_of_supply?.name,
        },
        branch_id: { label: isEditDetails?.branch?.branch, value: isEditDetails?.branch?._id },
        company_id: StorageService.getCompanyId(),
        expenses: customArray,
        file: isEditDetails?.file,
      }));

      const newArray = customArray?.map((el) => ({
        ...el,
        gst: calcGst(el?.tax, el?.amount, isEditDetails?.tax_type),
      }));
      setGstTypeAmount(newArray);
      setIsSupply(isEditDetails?.vendor_detail);
      setAccountType(isEditDetails?.payment_mode?.account_sub_category);
    }
  }, [isEditDetails]);

  useEffect(() => {
    if (!isEditDetails?.isEdit && !form?.is_invoice) {
      setForm((s) => ({ ...s, vendor_id: {}, account_id: '', account_sub_category: 15 }));
    }
  }, [form?.is_invoice, isEditDetails]);

  // ─── helpers ────────────────────────────────────────────────────────────────
  const calculateTotalAmount = () => {
    const exTotal = expenseArray?.reduce((total, item) => {
      return total + (parseFloat(item?.amount) || 0);
    }, 0);
    return exTotal.toFixed(2);
  };

  const calculatePreTaxSubTotal = () => {
    if (!form?.is_gst || form?.tax_type === 1) return calculateTotalAmount();
    const preTax = expenseArray?.reduce((total, item) => {
      const amount = parseFloat(item?.amount) || 0;
      const tax = parseFloat(item?.tax) || 0;
      const taxAmt = tax > 0 ? parseFloat(((amount * tax) / (100 + tax)).toFixed(2)) : 0;
      return total + (amount - taxAmt);
    }, 0);
    return preTax.toFixed(2);
  };

  const sumAmount = () => {
    const exTotal = gstTypeAmount?.reduce((total, item) => {
      return total + (parseFloat(item?.gst * 2) || 0);
    }, 0);
    return exTotal.toFixed(2);
  };

  const renderTotal = (action = false) => {
    const rawTotal = +calculateTotalAmount();
    const isGstVisible = form?.is_gst && form?.vendor_id?.value && form?.place_of_supply?.label;
    if (form?.tax_type === 1 && isGstVisible) {
      const gst = +sumAmount();
      return action ? (rawTotal + gst).toFixed(2) : `₹ ${(rawTotal + gst).toFixed(2)}`;
    }
    return action ? rawTotal.toFixed(2) : `₹ ${rawTotal.toFixed(2)}`;
  };

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(0, object.target.maxLength);
    }
  };

  // ─── form handlers ──────────────────────────────────────────────────────────
  // ✅ FIX: clear isSupply + place_of_supply when branch changes

  // ─── 1. handleOnChange — kuch nahi karna, original rakhein ───────────────────
  const handleOnChange = async (name, value) => {
    const stateObj = { ...form, [name]: value };
    setForm(stateObj);

    if (!!formError) {
      const validationResult = await utils.checkFormError(
        { ...stateObj },
        errorSchema.addExpenseAccountSchema
      );
      if (validationResult === true) setFormError("");
      else setFormError(validationResult);
    }
  };

  const handleExpenseChange = async (value, index, name) => {
    const list = [...expenseArray];
    list[index][name] = value;
    setExpenseArray(list);

    const arrayData = list?.map((el) => ({
      ...el,
      category: el?.category?.value ? el?.category?.value : '',
    }));

    if (!utils.isObjectKeyEmpty(formError)) {
      const validationResult = await utils.dynamicCheckFormError(
        { ...form, expenseArray: arrayData },
        errorSchema.addExpenseAccountSchema
      );
      if (validationResult === true) setFormError("");
      else setFormError(validationResult);
    }
  };

  const addExpenseInput = () => setExpenseArray((prev) => [...prev, expenseInit]);

  const removeExpenseInput = (index) => {
    const newExpense = [...expenseArray];
    newExpense.splice(index, 1);
    setExpenseArray(newExpense);
  };

  // ─── API handlers ────────────────────────────────────────────────────────────
  const getMasterData = async () => {
    try {
      const detailsAccount = masterData?.account_category?.sub_category?.map((item) => ({
        label: item?.name,
        value: item?.id,
        category_id: masterData?.account_category?.id,
      }));
      const gstList = masterData?.gst_percentage_list?.map((item) => ({
        ...item, label: item?.name, value: item?.id,
      }));
      if (detailsAccount && gstList) {
        if (!isEditDetails?.isEdit) {
          setForm({ ...form, account_category: 1, account_sub_category: 15 });
          setAccountType('');
        }
        setExpenseTypeList(detailsAccount?.filter((el) => el?.value != 26 && el?.value != 28 && el.id !== 11));
        setGstTaxList(gstList);
      }
    } catch { }
  };

  const getExpenseHandler = async () => {
    try {
      const res = await getChartExpense({
        company_id: StorageService.getCompanyId(),
        category_id: 5,
        sub_category_id: 1,
      });
      if (res?.responseCode === 200) {
        const { category_id, sub_category_id } = res?.data;
        const details = res?.data?.categories?.map((item) => ({ label: item?.name, value: item?._id }));
        const updatedList = expenseArray.map((item) => ({ ...item, category_id, sub_category_id }));
        if (!isEditDetails?.isEdit) setExpenseArray(updatedList);
        setExpenseList(details?.reverse());
      }
    } catch { }
  };

  const getAccountListHandler = async () => {
    setAccountLoading(true);
    try {
      const res = await getUserAccountList({
        company_id: StorageService?.getCompanyId(),
        category_id: parseInt(form?.account_category),
        sub_category_id: parseInt(form?.account_sub_category),
        firm_id: form?.branch_id?.firm_id?._id || StorageService?.getFirmId(),
      });
      if (res?.responseCode === 200) {
        setAccountLoading(false);
        const details = res?.data?.account_list?.map((item) => ({ label: item?.name, value: item?._id }));
        setAccountList(details);
        handleOnChange("account_id", isEditDetails?.payment_mode?.account?._id
          ? isEditDetails?.payment_mode?.account?._id
          : (details[0]?.value ? details[0]?.value : ""));
      } else setAccountLoading(false);
    } catch { setAccountLoading(false); }
  };

  const handleFileChange = async (e) => {
    const file = e?.target?.files[0];
    if (["image/gif", "image/jpeg", "image/png"].includes(file?.type)) {
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("file", file);
        const res = await uploadFiles(formData);
        if (res?.responseCode === 200) {
          handleOnChange("file", [...form?.file, { filename: res?.data?.filename, path: res?.data?.path }]);
          setLoading(false);
          toast.success("Document added");
        }
      } catch { setLoading(false); }
    } else {
      toast.error("Invalid file, choose jpeg/png images");
    }
  };

  const documentRemove = (index) => {
    const newFile = [...form?.file];
    newFile.splice(index, 1);
    setForm({ ...form, file: newFile });
    toast.success("Document Deleted");
  };

  const onHandleSubmit = async (approve) => {
    const arrayData = expenseArray?.map((el) => ({
      ...el,
      category: el?.category?.value ? el?.category?.value : '',
    }));

    const validationResult = await utils.dynamicCheckFormError(
      { ...form, expenseArray: arrayData },
      errorSchema.addExpenseAccountSchema
    );

    const formattedExpenseArray = expenseArray.map((expense) => ({
      ...expense,
      amount: parseFloat(parseFloat(expense.amount || 0).toFixed(2)),
      category: {
        _id: expense?.category?.value || '',
        name: expense?.category?.label || '',
      },
    }));
    formattedExpenseArray.forEach((obj) => {
      if (!form?.is_gst) delete obj.tax;
      delete obj.category_id;
      delete obj.sub_category_id;
      delete obj.gst_amount;
    });

    const payload = {
      ...form,
      expenses: formattedExpenseArray,
      total_amount: +renderTotal(true),
      sub_total: +calculatePreTaxSubTotal(),
      place_of_supply: form?.place_of_supply?._id ? form.place_of_supply : {},
      branch_id: form?.branch_id?.value ? form?.branch_id?.value : '',
      vendor_id: form?.vendor_id?.value ? form?.vendor_id?.value : '',
    };
    delete payload.amount;

    if (validationResult == true) {
      approve == 0 ? setIsLoaddingForSave(true) : setIsLoadding(true);
      try {
        const res = await addExpenseAccount(payload);
        if (res?.responseCode == 200) {
          setIsLoadding(false);
          setIsLoaddingForSave(false);
          props?.callBackFreight();
          props?.closeModal();
          toast.success(res?.responseMessage);
          navigate("/accounting/ptransactions")
        } else {
          setIsLoadding(false);
          setIsLoaddingForSave(false);
        }
      } catch (error) {
        setIsLoaddingForSave(false);
        setIsLoadding(false);
        toast.error(error?.message);
      }
    } else {
      setFormError(validationResult);
    }
  };

  const SendFor = () => { onHandleSubmit(1); setAprroveStatus(1); };
  const addFreight = () => { onHandleSubmit(0); setAprroveStatus(0); };

  const updateGeneralExpense = async () => {
    setIsLoadding(true);
    try {
      const payload = {
        company_id: form?.company_id,
        date: new Date(form?.date),
        account_category: form?.account_category ? parseInt(form?.account_category) : "",
        account_sub_category: form?.account_sub_category ? parseInt(form?.account_sub_category) : "",
        account_id: form?.account_id || "",
        voucher_id: isEditDetails?._id,
        vendor_id: isEditDetails?.vendor_detail?._id || '',
        vendor_type: isEditDetails?.vendor_type,
        old_account_id: form?.old_account_id,
      };
      const res = await makePaymentApi(payload);
      if (res?.responseCode == 200) {
        setIsLoadding(false);
        setIsLoaddingForSave(false);
        props?.callBackFreight();
        props?.closeModal();
        toast.success(res?.responseMessage);
      } else {
        setIsLoadding(false);
        setIsLoaddingForSave(false);
        toast.error(res?.responseMessage);
      }
    } catch (error) {
      setIsLoaddingForSave(false);
      setIsLoadding(false);
      toast.error(error?.message);
    }
  };

  // ─── fetch functions ─────────────────────────────────────────────────────────
  const fetchBranch = async (search, page, limit) => {
    const res = await getBranchListApi({
      company_id: StorageService.getCompanyId(),
      firm_id: StorageService.getFirmId(),
      offset: page, limit, search,
    });
    if (res?.responseCode === 200) {
      setLoading(false);
      const list = res?.data?.branch_list?.map((i) => ({ ...i, label: i?.branch, value: i?._id }));
      if (!form?.branch_id?.value && list?.length === 1) setForm((s) => ({ ...s, branch_id: list[0] }));
      return { items: list, total: res?.data?.total_record };
    } else setLoading(false);
  };

  // Generic vendor fetch (fallback for staff/unmatched types)
  const fetchVender = async (search, page, limit) => {
    const res = await venderDropdownApi({
      company_id: StorageService.getCompanyId(),
      firm_id: form?.branch_id?.firm_id?._id || StorageService.getFirmId(),
      offset: page, limit, search,
    });
    if (res?.responseCode === 200) {
      setLoading(false);
      const list = res?.data?.vendor_list?.map((i) => ({ ...i, label: i?.name, value: i?._id, gst_state: i?.gst_state }));
      return { items: list, total: res?.data?.total_record };
    } else setLoading(false);
  };

  // ✅ FIX: all useCallback deps use `form?.branch_id?.value` (stable string)
  const fetchSupplier = useCallback(async (search, page, limit) => {
    try {
      const res = await getAllSupplier({
        company_id: StorageService.getCompanyId(),
        offset: page, limit, search,
        firm_id: form?.branch_id?.firm_id?._id || StorageService.getFirmId(),
      });
      if (res?.responseCode === 200) {
        const list = res.data.supplier_list.map((i) => ({ ...i, label: i.name, value: i._id }));
        return { items: list, total: res.data.total_record || list.length };
      }
      toast.error(res?.responseMessage);
      return { items: [], total: 0 };
    } catch { return { items: [], total: 0 }; }
  }, [form?.branch_id?.value]);

  const fetchVendor = useCallback(async (search, page, limit) => {
    try {
      const res = await venderDropdownApi({
        company_id: StorageService.getCompanyId(),
        offset: page, limit, search,
        firm_id: form?.branch_id?.firm_id?._id || StorageService.getFirmId(),
      });
      if (res?.responseCode === 200) {
        const list = res.data.vendor_list.map((i) => ({ ...i, label: i.name, value: i._id, gst_state: i.gst_state }));
        return { items: list, total: res.data.total_record || list.length };
      }
      toast.error(res?.responseMessage);
      return { items: [], total: 0 };
    } catch { return { items: [], total: 0 }; }
  }, [form?.branch_id?.value]);

  const fetchParty = useCallback(async (search, page, limit) => {
    try {
      const res = await getConsignorDropdownListData2({
        company_id: StorageService.getCompanyId(),
        offset: page, limit, search,
        firm_id: form?.branch_id?.firm_id?._id || StorageService.getFirmId(),
      });
      if (res?.responseCode === 200) {
        const list = res.data.consignor_list.map((i) => ({ ...i, label: i.name, value: i._id }));
        return { items: list, total: res.data.total_record || list.length };
      }
      toast.error(res?.responseMessage);
      return { items: [], total: 0 };
    } catch { return { items: [], total: 0 }; }
  }, [form?.branch_id?.value]);

  const fetchDriver = useCallback(async (search, page, limit) => {
    try {
      const res = await getDriverDropdownListData({
        company_id: StorageService.getCompanyId(),
        offset: page, limit, search,
        driver_type: [1, 3],
        firm_id: form?.branch_id?.firm_id?._id || StorageService.getFirmId(),
      });
      if (res?.responseCode === 200) {
        const list = res.data.driver_list.map((i) => ({ ...i, label: i.name, value: i._id }));
        return { items: list, total: res.data.total_record || list.length };
      }
      toast.error(res?.responseMessage);
      return { items: [], total: 0 };
    } catch { return { items: [], total: 0 }; }
  }, [form?.branch_id?.value]);

  const fetchFuelStation = useCallback(async (search, page, limit) => {
    try {
      const res = await getFuelApi({
        company_id: StorageService.getCompanyId(),
        offset: page, limit, search,
        firm_id: form?.branch_id?.firm_id?._id || StorageService.getFirmId(),
      });
      if (res?.responseCode === 200) {
        const list = res.data.fuelstation_list.map((i) => ({ ...i, label: i.name, value: i._id }));
        return { items: list, total: res.data.total_record || list.length };
      }
      toast.error(res?.responseMessage);
      return { items: [], total: 0 };
    } catch { return { items: [], total: 0 }; }
  }, [form?.branch_id?.value]);

  const fetchFuelCard = useCallback(async (search, page, limit) => {
    try {
      const res = await getFuelCardAccountDropdownData({
        company_id: StorageService.getCompanyId(),
        offset: page, limit, search,
        firm_id: form?.branch_id?.firm_id?._id || StorageService.getFirmId(),
      });
      if (res?.responseCode === 200) {
        const list = res.data.fuelcard_list.map((i) => ({ ...i, label: i.account_number, value: i._id }));
        return { items: list, total: res.data.total_record || list.length };
      }
      toast.error(res?.responseMessage);
      return { items: [], total: 0 };
    } catch { return { items: [], total: 0 }; }
  }, [form?.branch_id?.value]);

  const fetchFastag = useCallback(async (search, page, limit) => {
    try {
      const res = await getFastagCompanyDropdownData({
        company_id: StorageService.getCompanyId(),
        offset: page, limit, search,
        firm_id: form?.branch_id?.firm_id?._id || StorageService.getFirmId(),
      });
      if (res?.responseCode === 200) {
        const list = res.data.fastag_company.map((i) => ({ ...i, label: i.name, value: i._id }));
        return { items: list, total: res.data.total_record || list.length };
      }
      toast.error(res?.responseMessage);
      return { items: [], total: 0 };
    } catch { return { items: [], total: 0 }; }
  }, [form?.branch_id?.value]);

  const fetchStaff = useCallback(async (search, page, limit) => {
    try {
      const res = await getStaffListData({
        company_id: StorageService.getCompanyId(),
        offset: page, limit, search,
        firm_id: form?.branch_id?.firm_id?._id || StorageService.getFirmId(),
      });
      if (res?.responseCode === 200) {
        const list = res.data.list.map((i) => ({ ...i, label: i.name, value: i._id }));
        return { items: list, total: res.data.total_record || list.length };
      }
      toast.error(res?.responseMessage);
      return { items: [], total: 0 };
    } catch { return { items: [], total: 0 }; }
  }, [form?.branch_id?.value]);

  const getStatesByApi = async () => {
    try {
      const response = await getStatesData({ countryCode: "IN", stateCode: "" });
      if (response?.responseCode === 200) {
        const optionsState = response?.data?.map((d) => ({ ...d, label: d?.name, value: d?.name }));
        StorageService.setStates(JSON.stringify([...optionsState]));
        setStatesList(optionsState);
      } else if (response) toast.error(response?.responseMessage);
    } catch { toast.error("An unexpected error occurred. Please try again."); }
  };



  // ─── vendor type config ──────────────────────────────────────────────────────
  const listMap = {
    1: { placeholder: "Select Supplier", fetchData: fetchSupplier },
    2: { placeholder: "Select Party", fetchData: fetchParty },
    3: { placeholder: "Select Driver", fetchData: fetchDriver },
    4: { placeholder: "Select Vendor", fetchData: fetchVendor },
    5: { placeholder: "Select Fuel Station", fetchData: fetchFuelStation },
    6: { placeholder: "Select Fuel Card", fetchData: fetchFuelCard },
    7: { placeholder: "Select Fastag", fetchData: fetchFastag },
    8: { placeholder: "Select Staff", fetchData: fetchStaff },
  };

  const vendorTypeSelectOptions = (masterData?.vendor_type_list || [])
    .filter((item) => ![6, 7].includes(item?.id))
    .map((item) => ({ label: item?.name, value: item?.id }));

  const activeVendorConfig = listMap[form?.vendor_type] || {
    placeholder: "Select Vendor",
    fetchData: fetchVender,
  };

  // ─── modal / callback config ─────────────────────────────────────────────────
  const handleTableIndexAction = (name, index) => {
    if (name === "category") {
      setAddNewExpense(true);
      setGeneralExpensesIndex(index);
    }
  };

  const callBackApi = (data) => {
    const object = { label: data?.category?.name, value: data?.category?._id };
    handleExpenseChange(object, generalExpensesIndex, "category");
    setGeneralExpensesIndex(null);
    getExpenseHandler();
    setAddNewExpense(false);
  };

  const generalExpenseCategoryModal = {
    isOpen: addNewExpense,
    closeModal: () => setAddNewExpense(false),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: 'Expense Category',
    submitTitle: 'Add Expense Category',
    footerPart: true,
    label: 'Expenses Category',
    placeholder: 'Expenses Category',
    callBackApi,
    titleName: "Add Expense Category",
  };

  const propsExpenses = {
    ...props,
    isLoadding,
    disabled: aprroveStatus == 0 ? isLoaddingforsave : isLoadding,
    isLoaddingforsave,
    modalMainClass: 'mdOffcanvas',
    modalTitle: "General Expenses",
    sendApprovalButtonTitle: isLoadding ? 'Loading...' : (isEditDetails?.isEdit ? "Update & Save" : "Send for Approval"),
    showUpdateButton: true,
    onSubmit: isEditDetails?.isEdit ? updateGeneralExpense : addFreight,
    submitTitle: isEditDetails?.isEdit ? "Complete Payment" : "Add General Expense",
    footerPart: isEditDetails?.isEdit ? false : true,
    sendFor: isLoadding ? 'Loading...' : (isEditDetails?.isEdit ? updateGeneralExpense : SendFor),
    isShowSendForApprovalButton: false,
  };

  const handleAddVendorButton = () => {
    if (form?.vendor_type === 1) setShowOffcanvasSupplier(true);
    else if (form?.vendor_type === 2) setShowOffcanvasConsignor(true);
    else if (form?.vendor_type === 3) setShowOffcanvasDriver(true);
    else if (form?.vendor_type === 5) setShowOffcanvasFuel(true);
    else if (form?.vendor_type === 8) setShowOffcanvasStaff(true);
    else setIsOpenVenderModal(true);
  };

  const showAddButton = () => {
    if (form?.vendor_type === 1) return masterChildSupplier?.create === 1;
    if (form?.vendor_type === 4) return masterChildVendors?.create === 1;
    if (form?.vendor_type === 2) return masterChildConsignor?.create === 1;
    if (form?.vendor_type === 3) return masterChildDriver?.create === 1;
    if (form?.vendor_type === 5) return masterChildFuelStation?.create === 1;
    if (form?.vendor_type === 8) return masterChildStaff?.create === 1;

    return false;
  };

  // ─── render ──────────────────────────────────────────────────────────────────
  return (
    <>
      <CommonCanvas {...propsExpenses}>
        <div className="offcanvas-body bg-white">
          <div className="__addExp_body">
            <div className="flxInr">

              {/* Branch */}
              <div className="halfDiv ps-3">
                <CityDropdownForTrip
                  label={"Branch"}
                  placeholder="Select Branch"
                  fetchData={fetchBranch}
                  pageSize={20}
                  onChange={(data) => handleOnChange("branch_id", data)}
                  selectedItem={form?.branch_id}
                  error={!!formError['branch_id.label']}
                  errorMessage={formError['branch_id.label']}
                  disabled={isEditDetails?.isEdit ? true : false}
                />
                {form?.branch_id?.firm_id?.firm && (
                  <p className='offcanvas_heading_head' style={{ fontWeight: 400, fontSize: "12px", marginLeft: "5px", color: "#4A5565" }}>
                    <img src={FirmImg} className='firm_icon_img' style={{ color: "#4A5565" }} />{" "}
                    {form?.branch_id?.firm_id?.firm}
                  </p>
                )}
              </div>

              {/* Expense Date */}
              <div className="halfDiv pe-3">
                <CommonDatePicker
                  name="date"
                  label="Expense Date"
                  placeholderText="Expense Date"
                  startDate={form?.date}
                  setStartDate={(data) => handleOnChange("date", data)}
                  maxDate={new Date()}
                  error={formError?.date}
                  focus={!!formError?.date}
                  errorShow={true}
                  disabled={isEditDetails?.isEdit ? true : false}
                />
              </div>

              {/* Add Invoice Details toggle */}
              <div className="singleDiv _pMode_exbx px-3">
                <CommonSwitch
                  id="is_invoice"
                  name="is_invoice"
                  label="Add Invoice Details"
                  value={form?.is_invoice}
                  checked={form?.is_invoice}
                  onChange={({ target: { name, checked } }) => handleOnChange(name, checked ? true : false)}
                  disabled={form?.is_gst || isEditDetails?.isEdit}
                />
              </div>

              {/* Invoice fields */}
              {form.is_invoice ? (
                <>
                  {/* Vendor Type */}
                  <div className="halfDiv ps-3">
                    <CustomSelect
                      label="Vendor Type"
                      placeholder="Select Vendor Type"
                      options={vendorTypeSelectOptions}
                      value={vendorTypeSelectOptions.find((i) => i.value === form?.vendor_type) || null}
                      onSelect={(data) => handleOnChange("vendor_type", data?.value)}
                      error={formError["vendor_type"]}
                      errorShow={true}
                      disabled={isEditDetails?.isEdit ? true : false}
                    />
                  </div>

                  {/* empty half to keep grid balanced */}
                  <div className="halfDiv pe-3" />

                  {/* ✅ FIX: key includes both vendor_type AND branch_id value */}
                  <div className="halfDiv ps-3">
                    <CityDropdownForTrip
                      key={`${form?.vendor_type}_${form?.branch_id?.value}`}
                      label={activeVendorConfig.placeholder}
                      placeholder={activeVendorConfig.placeholder}
                      fetchData={activeVendorConfig.fetchData}
                      pageSize={20}
                      // onChange={(data) => {
                      //   handleOnChange("vendor_id", data); setIsSupply(data); if (data?.gst_no) {
                      //     setForm((s) => ({
                      //       ...s,
                      //       vendor_id: data,
                      //       is_invoice: true,
                      //       is_gst: 1,
                      //       tax_type: 1,
                      //     }));
                      //   } else {
                      //     setForm((s) => ({
                      //       ...s,
                      //       vendor_id: data,
                      //       is_gst: 0,
                      //       tax_type: 0,
                      //     }));
                      //   }
                      // }}
                      onChange={(data) => {
                        handleOnChange("vendor_id", data);
                        setIsSupply(data);
                        if (data?.gst_state?.label || data?.gst_state?.value) {
                          setForm((s) => ({
                            ...s,
                            vendor_id: data,
                            is_invoice: true,
                            is_gst: 1,
                            tax_type: 1,
                          }));
                        } else {
                          setForm((s) => ({
                            ...s,
                            vendor_id: data,
                            is_gst: 0,
                            tax_type: 0,
                          }));
                        }
                      }}
                      addButtonAction={handleAddVendorButton}
                      isAddButton={showAddButton()}
                      selectedItem={form?.vendor_id?.value ? form?.vendor_id : null}
                      error={!!formError['vendor_id.label']}
                      errorMessage={formError['vendor_id.label']}
                      disabled={isEditDetails?.isEdit ? true : false}
                      isClearOption={form?.vendor_id?.value ? true : false}
                      isClearHandleChange={() => { handleOnChange("vendor_id", {}); setIsSupply({}); }}
                    />
                  </div>

                  {/* Place of Supply */}
                  <div className="halfDiv pe-3">
                    <CustomSelect
                      label="Place of Supply"
                      options={statesList}
                      onSelect={(data) => handleOnChange("place_of_supply", data)}
                      placeholder="Place of Supply"
                      value={form?.place_of_supply}
                      error={formError["place_of_supply.label"]}
                      errorShow={true}
                      disabled={isEditDetails?.isEdit ? true : false}
                    />
                  </div>

                  {/* Invoice Number */}
                  <div className="halfDiv ps-3">
                    <CommonInput
                      type="text"
                      label="Invoice Number"
                      placeholder="Invoice Number"
                      name="invoice_number"
                      maxLength={15}
                      value={form?.invoice_number}
                      onChange={({ target: { name, value } }) => handleOnChange(name, value)}
                      focus={!!formError?.invoice_number}
                      error={formError.invoice_number}
                      errorShow={true}
                      disabled={isEditDetails?.isEdit ? true : false}
                    />
                  </div>

                  {/* Invoice Date */}
                  <div className="halfDiv pe-3">
                    <CommonDatePicker
                      name="invoice_date"
                      label="Invoice Date"
                      placeholderText="Invoice Date"
                      startDate={form?.invoice_date}
                      setStartDate={(data) => handleOnChange("invoice_date", data)}
                      error={formError?.invoice_date}
                      focus={!!formError?.invoice_date}
                      errorShow={true}
                      disabled={isEditDetails?.isEdit ? true : false}
                    />
                  </div>
                </>
              ) : <></>}

              {/* GST toggle */}
              {form?.is_invoice ? (
                <div className="singleDiv">
                  <div className="__gstToggle_bx">
                    <CommonSwitch
                      id="Exp_with_GST"
                      name="is_gst"
                      label="Expense with GST"
                      value={form?.is_gst}
                      checked={form?.is_gst}
                      onChange={({ target: { name, checked } }) => {
                        handleOnChange(name, checked ? 1 : 0);
                        if (checked) setForm((s) => ({ ...s, is_invoice: true, tax_type: 1 }));
                        else setForm((s) => ({ ...s, tax_type: 0 }));
                      }}
                      disabled={isEditDetails?.isEdit ? true : false}
                    />
                  </div>
                </div>
              ) : <></>}

              {/* Tax type radio */}
              {form.is_gst ? (
                <div className='d-flex gap-2 px-3' style={{ width: '100%', flexWrap: 'wrap' }}>
                  <span style={{ flex: '100%' }}>Amount</span>
                  {constant.Tax_type_amount?.map((el, ind) => (
                    <React.Fragment key={ind}>
                      <div className='_dualCheckr_bx' style={{ marginRight: '10px' }}>
                        <input
                          className="form-check-input"
                          id={+ind + "tax_type" + el?.value}
                          type="radio"
                          name="tax_type"
                          checked={form.tax_type === el?.value}
                          value={form.tax_type ? form.tax_type : ""}
                          onChange={() => handleOnChange("tax_type", +el?.value)}
                          disabled={isEditDetails?.isEdit ? true : false}
                        />
                        <label htmlFor={+ind + "tax_type" + el.value} className="form-check-label">
                          {el.label}
                        </label>
                      </div>
                    </React.Fragment>
                  ))}
                </div>
              ) : <></>}

              {/* Expense table */}
              <div className="singleDiv">
                <div className="_catGry_tableBx _withGst_catGry">
                  {/* Table header */}
                  {form.is_gst ? (
                    <div className="__catrTb_row __catrTb_head">
                      <div className="__cat_childs"><h5>Expense Category</h5></div>
                      <div className="__cat_childs"><h5>Tax</h5></div>
                      <div className="__cat_childs"><h5>Amount</h5></div>
                    </div>
                  ) : (
                    <div className="__catrTb_row __catrTb_head">
                      <div className="__cat_childs"><h5>Expense Category</h5></div>
                      <div className="__cat_childs"><h5>Amount</h5></div>
                    </div>
                  )}

                  {/* Table rows */}
                  {expenseArray?.map((exp, index) => (
                    <React.Fragment key={index}>
                      {form?.is_gst ? (
                        <div className="__catrTb_row __catrTb_body">
                          {/* Category + Description */}
                          <div className="__cat_childs">
                            <div>
                              <CustomSelect
                                name="category"
                                options={expenseList}
                                onSelect={(data) => handleExpenseChange(data, index, "category")}
                                placeholder="Expense Category"
                                error={formError[`expenseArray[${index}].category`]}
                                focus={!!formError[`expenseArray[${index}].category`]}
                                value={expenseArray[index].category}
                                isAddButton={hasLinkCharofAccountPermission?.canCreate ? true : false}
                                addButtonAction={() => handleTableIndexAction("category", index)}
                                errorShow={true}
                                disabled={isEditDetails?.isEdit ? true : false}
                              />
                            </div>
                            <div className="mt-1">
                              <CommonInput
                                type="text"
                                placeholder="Item Description"
                                name="description"
                                value={exp?.description}
                                onChange={({ target: { value } }) => handleExpenseChange(value, index, "description")}
                                focus={!!formError[`expenseArray[${index}].description`]}
                                error={formError[`expenseArray[${index}].description`]}
                                errorShow={true}
                                disabled={isEditDetails?.isEdit ? true : false}
                              />
                            </div>
                          </div>

                          {/* Tax + Type */}
                          <div className="__cat_childs">
                            <div>
                              <CustomSelect
                                name="tax"
                                options={gstTaxList}
                                onSelect={(data) => handleExpenseChange(data?.value, index, "tax")}
                                placeholder="Tax"
                                focus={!!formError[`expenseArray[${index}].tax`]}
                                error={formError[`expenseArray[${index}].tax`]}
                                value={gstTaxList?.find((i) => i.value == exp?.tax)}
                                errorShow={true}
                                disabled={isEditDetails?.isEdit ? true : false}
                              />
                            </div>
                            <div className="mt-1">
                              <CustomSelect
                                options={arryOptions}
                                placeholder="Type"
                                onSelect={(data) => handleExpenseChange(data?.value, index, "type")}
                                focus={!!formError[`expenseArray[${index}].type`]}
                                error={formError[`expenseArray[${index}].type`]}
                                value={arryOptions?.find((i) => i.value == exp?.type)}
                                errorShow={true}
                                disabled={isEditDetails?.isEdit ? true : false}
                              />
                            </div>
                          </div>

                          {/* Amount + HSN */}
                          <div className="__cat_childs">
                            <div>
                              <CommonInput
                                type="text"
                                placeholder="Amount (₹)"
                                name="amount"
                                maxLength="10"
                                onInput={maxLengthCheck}
                                value={exp?.amount}
                                onChange={({ target: { value } }) => {
                                  if (/^\d*(\.\d{0,2})?$/.test(value)) handleExpenseChange(value, index, "amount");
                                }}
                                focus={!!formError[`expenseArray[${index}].amount`]}
                                error={formError[`expenseArray[${index}].amount`]}
                                errorShow={true}
                                disabled={isEditDetails?.isEdit ? true : false}
                              />
                            </div>
                            <div className="mt-1">
                              <CommonInput
                                type="text"
                                placeholder="HSN Code"
                                name="hsn_code"
                                value={exp?.hsn_code}
                                onChange={({ target: { value } }) => {
                                  if (/^\d*$/.test(value)) handleExpenseChange(value, index, "hsn_code");
                                }}
                                focus={!!formError[`expenseArray[${index}].hsn_code`]}
                                error={formError[`expenseArray[${index}].hsn_code`]}
                                errorShow={true}
                                maxLength={6}
                                disabled={isEditDetails?.isEdit ? true : false}
                              />
                            </div>
                          </div>

                          {expenseArray.length > 1 && !isEditDetails?.isEdit && (
                            <div className="mt-1">
                              <img className="_delExp" src={Images.DELETEICON.default} alt="" onClick={() => removeExpenseInput(index)} />
                            </div>
                          )}
                        </div>
                      ) : (
                        /* Non-GST row */
                        <div className="__catrTb_row __catrTb_body">
                          <div className="__cat_childs">
                            <div className="mt-1">
                              <CustomSelect
                                name="category"
                                options={expenseList}
                                onSelect={(data) => handleExpenseChange(data, index, "category")}
                                placeholder="Expense Category"
                                error={formError[`expenseArray[${index}].category`]}
                                focus={!!formError[`expenseArray[${index}].category`]}
                                value={expenseArray[index].category}
                                isAddButton={true}
                                addButtonAction={() => handleTableIndexAction("category", index)}
                                errorShow={true}
                                disabled={isEditDetails?.isEdit ? true : false}
                              />
                            </div>
                          </div>

                          <div className="mt-1">
                            <CommonInput
                              type="text"
                              placeholder="Item Description"
                              name="description"
                              value={exp?.description}
                              onChange={({ target: { value } }) => handleExpenseChange(value, index, "description")}
                              focus={!!formError[`expenseArray[${index}].description`]}
                              error={formError[`expenseArray[${index}].description`]}
                              errorShow={true}
                              disabled={isEditDetails?.isEdit ? true : false}
                            />
                          </div>

                          <div className="__cat_childs">
                            <div className="mt-1">
                              <CommonInput
                                type="text"
                                placeholder="Amount (₹)"
                                name="amount"
                                maxLength="10"
                                onInput={maxLengthCheck}
                                value={exp?.amount}
                                onChange={({ target: { value } }) => {
                                  if (/^\d*(\.\d{0,2})?$/.test(value)) handleExpenseChange(value, index, "amount");
                                }}
                                focus={!!formError[`expenseArray[${index}].amount`]}
                                error={formError[`expenseArray[${index}].amount`]}
                                errorShow={true}
                                disabled={isEditDetails?.isEdit ? true : false}
                              />
                            </div>
                          </div>

                          {expenseArray.length > 1 && !isEditDetails?.isEdit && (
                            <div className="mt-2">
                              <img className="_delExp" src={Images.DELETEICON.default} alt="" onClick={() => removeExpenseInput(index)} />
                            </div>
                          )}
                        </div>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>

              {/* Add More + totals */}
              <div className="singleDiv">
                <div className="totalExp_bal pt-2">
                  <button className="__adx_more" onClick={addExpenseInput} disabled={isEditDetails?.isEdit ? true : false}>
                    + Add More
                  </button>

                  <div className="__sideTl_detail" style={{ maxWidth: 'fit-content', minWidth: '155px' }}>
                    <div className="_alInvoiceSumry">
                      {(form?.is_gst && form?.vendor_id?.value && form?.place_of_supply?.label) ? (
                        <>
                          <div className="_invsSum_fx">
                            <p className="_blackText">Sub Total</p>
                            <p className="_blackText">{`₹ ${calculatePreTaxSubTotal()}`}</p>
                          </div>

                          {(
                            form?.place_of_supply?.label?.toLowerCase()?.trim() === isSupply?.gst_state?.label?.toLowerCase()?.trim() ||
                            form?.place_of_supply?.label?.toLowerCase()?.trim() === isSupply?.gst_state?.value?.toLowerCase()?.trim() ||
                            form?.place_of_supply?.value?.toLowerCase()?.trim() === isSupply?.gst_state?.label?.toLowerCase()?.trim() ||
                            form?.place_of_supply?.value?.toLowerCase()?.trim() === isSupply?.gst_state?.value?.toLowerCase()?.trim()
                          ) ? (
                            // Same state → CGST + SGST
                            gstTypeAmount?.map((el, idx) => (
                              <React.Fragment key={idx}>
                                <div className="_invsSum_fx">
                                  <p className="_blackText">CGST {el?.tax / 2}%</p>
                                  <p className="_blackText">{`₹ ${(el?.gst).toFixed(2)}`}</p>
                                </div>
                                <div className="_invsSum_fx">
                                  <p className="_blackText">SGST {el?.tax / 2}%</p>
                                  <p className="_blackText">{`₹ ${(el?.gst).toFixed(2)}`}</p>
                                </div>
                              </React.Fragment>
                            ))
                          ) : (
                            // Different state → IGST
                            gstTypeAmount?.map((el, idx) => (
                              <div key={idx} className="_invsSum_fx">
                                <p className="_blackText">IGST {el?.tax}%</p>
                                <p className="_blackText">{`₹ ${(el?.gst * 2).toFixed(2)}`}</p>
                              </div>
                            ))
                          )}

                          <div className="_invsSum_fx">
                            <p className="_blackText" style={{ marginRight: '5px' }}>Total</p>
                            <p className="_blackText">{renderTotal()}</p>
                          </div>
                        </>
                      ) : (
                        <div className="_invsSum_fx">
                          <p className="_blackText" style={{ marginRight: '5px' }}>Total</p>
                          <p className="_blackText">{`₹ ${calculateTotalAmount()}`}</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Attachment */}
              <div className="singleDiv _pMode_exbx px-3">
                <div className="_attatchmentBxs">
                  <p>Attachment</p>
                  <div className="__addExp_fileBx">
                    <input
                      type="file"
                      name=""
                      id="attachExp_file"
                      onChange={(e) => handleFileChange(e)}
                      disabled={loading || form?.file?.length >= 5 || isEditDetails?.isEdit}
                    />
                    <label htmlFor="attachExp_file">{loading ? "Uploadding" : "+ Attach File"}</label>
                    {formError?.file && <span className="input_drop_error">{formError?.file}</span>}
                  </div>
                  <div className="img_fnex_src">
                    {form?.file?.length > 0 && form?.file?.map((el, index) => (
                      <div key={index} className="pos-relative">
                        <img className="_pdfIcon_sigxe" src={`${masterData?.s3_url}${el?.path}`} alt="" />
                        {!isEditDetails?.isEdit && (
                          <span className="_clDel_icon">
                            <IoCloseCircle onClick={() => documentRemove(index)} />
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </CommonCanvas>

      {addNewExpense && <AddExpenseCategoryModal {...generalExpenseCategoryModal} />}

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${isOpenVenderModal ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: isOpenVenderModal ? 'visible' : 'hidden', zIndex: '1046' }}
      >
        {isOpenVenderModal && (
          <AddEditVendors
            isOpen={isOpenVenderModal}
            onClose={() => setIsOpenVenderModal(false)}
            setVenderSelection={(e) => setVenderSelection(e)}
            hideAddNewOption={false}
            branchFirmId={form?.branch_id?.firm_id}
          />
        )}
      </div>
      <div style={{ zIndex: '1045' }} className={isOpenVenderModal ? 'offBack_drop' : ''} />

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasSupplier ? "show" : ""}`}
        tabIndex={-1}
        style={{ visibility: showOffcanvasSupplier ? "visible" : "hidden", zIndex: '1046' }}
      >
        {showOffcanvasSupplier && (
          <AddEditSupplier
            isOpen={showOffcanvasSupplier}
            onClose={() => setShowOffcanvasSupplier(false)}
            callBackSupplier={(e) => setVenderSelection(e)}
            setVenderSelection={(e) => setVenderSelection(e)}
            branchFirmId={form?.branch_id?.firm_id || StorageService.getFirmId()}
            hideAddNewOption={false}
          />
        )}
      </div>
      <div style={{ zIndex: '1045' }} className={showOffcanvasSupplier ? 'offBack_drop' : ''} />

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasConsignor ? "show" : ""}`}
        tabIndex={-1}
        style={{ visibility: showOffcanvasConsignor ? "visible" : "hidden", zIndex: '1046' }}
      >
        {showOffcanvasConsignor && (
          <AddEditConsignor
            isOpen={showOffcanvasConsignor}
            onClose={() => setShowOffcanvasConsignor(false)}
            callBackSupplier={(e) => setVenderSelection(e)}
            setVenderSelection={(e) => setVenderSelection(e)}
            branchFirmId={form?.branch_id?.firm_id?._id || StorageService.getFirmId()}
            hideAddNewOption={false}
          />
        )}
      </div>
      <div style={{ zIndex: '1045' }} className={showOffcanvasConsignor ? 'offBack_drop' : ''} />

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasDriver ? "show" : ""}`}
        tabIndex={-1}
        style={{ visibility: showOffcanvasDriver ? "visible" : "hidden", zIndex: '1046' }}
      >
        {showOffcanvasDriver && (
          <AddEditOwnDriver
            isOpen={showOffcanvasDriver}
            onClose={() => setShowOffcanvasDriver(false)}
            callBackDriver={(e) => setVenderSelection(e)}
            setVenderSelection={(e) => setVenderSelection(e)}
            vehicleFirmId={form?.branch_id?.firm_id || StorageService.getFirmId()}
            hideAddNewOption={false}
          />
        )}
      </div>
      <div style={{ zIndex: '1045' }} className={showOffcanvasDriver ? 'offBack_drop' : ''} />

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasFuel ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: showOffcanvasFuel ? "visible" : "hidden", zIndex: '1046' }}
      >
        {showOffcanvasFuel &&
          <AddEditFuelStation
            isOpen={showOffcanvasFuel}
            onClose={() => setShowOffcanvasFuel(false)}
            callBackFuel={(e) => setVenderSelection(e)}
            setVenderSelection={(e) => setVenderSelection(e)}
            branchFirmId={form?.branch_id?.firm_id || StorageService.getFirmId()}
            hideAddNewOption={false}
          />
        }
      </div>
      <div style={{ zIndex: '1045' }} className={showOffcanvasFuel ? 'offBack_drop' : ''} />

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasStaff ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: showOffcanvasStaff ? 'visible' : 'hidden', zIndex: '1046' }}
      >
        {showOffcanvasStaff &&
          <AddEditStaff isOpen={showOffcanvasStaff}
            onClose={(e) => { setShowOffcanvasStaff(false); }}
            callBackStaff={(e) => setVenderSelection(e)}
            setVenderSelection={(e) => setVenderSelection(e)}
            branchFirmId={form?.branch_id?.firm_id || StorageService.getFirmId()}
            hideAddNewOption={false} />
        }
      </div>
      <div style={{ zIndex: '1045' }} className={showOffcanvasStaff ? 'offBack_drop' : ''}></div>
    </>
  );
};

export default AddExpensesModal;